import React from 'react';
import styles from '../carinagaldini_makeup/carinagaldini_makeup.module.scss';
import Background from './src/background-links.png';
import LinkPersonalizado7 from '../../components/LinkPersonalizado7/linkPersonalizado7.tsx';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import MapsIcon from '../../icons/mapsIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';
import CatalogIcon from '../../icons/catalogIcon.tsx';

const Carinagaldini_makeup: React.FC = () => {
    return (
        <div className={styles.carinagaldini_makeup}>
            <div className={styles["body-thunder"]} style={{
                backgroundImage: `url(${Background})`
            }}>
                <div
                    className={styles["container-thunder"]}
                >
                    <h1 className="pt-2">Carina Galdini</h1>
                    <p>MAQUIADORA PROFISSIONAL</p>
                    <div className={styles.links}>
                        <div className={styles["link-card"]}>
                            <LinkPersonalizado7
                                href="https://www.instagram.com/carinagaldini.makeup?igsh=dGozc2xpd3NhOXV6"
                                title="INSTAGRAM"
                                icon={<InstagramIcon height="30" color="#cbb353" />}
                                colorText="#333333"
                            />
                            <LinkPersonalizado7
                                href="https://wa.me/5517988232421?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio."
                                title="AGENDAR"
                                icon={<WhatsappIcon height="34" color="#cbb353" />}
                                colorText="#333333"
                            />
                            <LinkPersonalizado7
                                href="https://maps.app.goo.gl/6YZ4hRzySMqEqBPp9"
                                title="LOCALIZAÇÃO"
                                icon={<MapsIcon height="34" color="#cbb353" />}
                                colorText="#333333"
                            />
                            <LinkPersonalizado7
                                linkInterno={true}
                                href="/carinagaldini_makeup/sobremim"
                                title="SOBRE MIM"
                                icon={<CatalogIcon height="34" color="#cbb353" />}
                                colorText="#333333"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Carinagaldini_makeup;
